import axios from "axios";
import errorHandler from "Utils/error-handler";
import { getAccessToken } from "Helpers/session";
import { omitBy, isEmpty, isNil } from "lodash";
import { apiURL } from "Helpers/url";

const url = apiURL("/delivery_update");

export const listDeliveryUpdates = async (
  filters: any,
  sorting: any,
  pagination?: any,
  recaptchaToken?: string,
) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/list`,
      data: omitBy(
        {
          recaptchaToken,
          filters: omitBy(filters, (value) => isNil(value) || value === ""),
          pagination,
          sorting,
        },
        isNil,
      ),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () =>
        await listDeliveryUpdates(filters, pagination, sorting);
      const { value, code, message, stack } = await errorHandler.response(
        error,
        { callback },
      );
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const editDeliveryUpdates = async (input: any) => {
  const accessToken = getAccessToken();
  const payload = omitBy({ deliveryUpdates: input }, isNil);
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/timestamp/update
`,
      data: payload,
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await editDeliveryUpdates(input);
      const { value, code, message, stack } = await errorHandler.response(
        error,
        { callback },
      );
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const addDeliveryUpdates = async (input: any) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/create
`,
      data: omitBy(input, isNil),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await addDeliveryUpdates(input);
      const { value, code, message, stack } = await errorHandler.response(
        error,
        { callback },
      );
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const deleteDeliveryUpdates = async (input: any) => {
  const accessToken = getAccessToken();
  const payload = omitBy({ deliveryUpdates: input}, isNil);
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/delete/update
`,
      data: omitBy(payload, isNil),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await deleteDeliveryUpdates(input);
      const { value, code, message, stack } = await errorHandler.response(
        error,
        { callback },
      );
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};